import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.setHealthCheckSetting.loading;
export const selectErrorMessage = (state: RootState) =>
  state.setHealthCheckSetting.error;
export const setHealthCheckSettingResponse = (state: RootState) =>
  state.setHealthCheckSetting.setHealthCheckSettingResponse;
